<template>
    <div>
        <select-field
            :field="patientFields.sex"
            field-name="sex"
            v-model="sex"
            :errors="errors"
        />

        <date-field
            :field="patientFields.birthday"
            field-name="birthday"
            v-model="birthday"
            :errors="errors"
        />

        <hr class="my-5">

        <p>
            {{ $t("patient.consentDescription") }}
        </p>

        <checkbox-field
            :field="patientFields.is_study_consent"
            v-model="is_study_consent"
            field-name="is_study_consent"
            :errors="errors"
        />
        <checkbox-field
            :field="patientFields.is_genetic_study_consent"
            v-model="is_genetic_study_consent"
            field-name="is_genetic_study_consent"
            :errors="errors"
        />

    </div>
</template>

<script>
    import SelectField from "@/components/fields/SelectField";
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import DateField from "@/components/fields/DateField";
    import CheckboxField from "@/components/fields/CheckboxField";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "PatientGeneralData",
        components: {CheckboxField, DateField, SelectField},
        computed: {
            ...mapState([
                'patientFields',
            ]),
            ...mapStateProperty([
                'patient.sex',
                'patient.center',
                'patient.birthday',
                'patient.is_study_consent',
                'patient.is_genetic_study_consent',
            ]),
            errors() {
                let errors = {};
                if (this.$v.birthday.$error) {
                    errors['birthday']  = [this.$t('error.required')];
                }
                if (this.$v.is_study_consent.$error) {
                    errors['is_study_consent']  = [this.$t('error.required')];
                }
                return errors;
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                return !this.$v.$invalid;
            },
            back() {
                return true;
            }
        },
        validations: {
            birthday: {
                required
            },
            is_study_consent: {
                required,
                shouldBeTrue: (value => value === true),
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    hr {
        background-color: $primary;
    }
</style>